/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SummarizationsControllerFindOneQueryResponse, SummarizationsControllerFindOnePathParams, SummarizationsControllerFindOneQueryParams, SummarizationsControllerFindOne400, SummarizationsControllerFindOne401, SummarizationsControllerFindOne403, SummarizationsControllerFindOne404 } from "../../models/documentSummariesController/SummarizationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { summarizationsControllerFindOne } from "../../clients/document-summariesService/summarizationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const summarizationsControllerFindOneQueryKey = (documentId: SummarizationsControllerFindOnePathParams["documentId"], renditionId: SummarizationsControllerFindOnePathParams["renditionId"], summaryId: SummarizationsControllerFindOnePathParams["summaryId"], params: SummarizationsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/summaries/:summaryId',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    summaryId: summaryId
  }
}, ...(params ? [params] : [])] as const;
export type SummarizationsControllerFindOneQueryKey = ReturnType<typeof summarizationsControllerFindOneQueryKey>;
export function summarizationsControllerFindOneQueryOptions(documentId: SummarizationsControllerFindOnePathParams["documentId"], renditionId: SummarizationsControllerFindOnePathParams["renditionId"], summaryId: SummarizationsControllerFindOnePathParams["summaryId"], params?: SummarizationsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = summarizationsControllerFindOneQueryKey(documentId, renditionId, summaryId, params);
  return queryOptions<SummarizationsControllerFindOneQueryResponse, ResponseErrorConfig<SummarizationsControllerFindOne400 | SummarizationsControllerFindOne401 | SummarizationsControllerFindOne403 | SummarizationsControllerFindOne404>, SummarizationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && summaryId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return summarizationsControllerFindOne(documentId, renditionId, summaryId, params, config);
    }
  });
}

/**
 * @description Returns detailed information about a specific summary
 * @summary Get a specific summary
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/summaries/:summaryId}
 */
export function useSummarizationsControllerFindOne<TData = SummarizationsControllerFindOneQueryResponse, TQueryData = SummarizationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = SummarizationsControllerFindOneQueryKey>(documentId: SummarizationsControllerFindOnePathParams["documentId"], renditionId: SummarizationsControllerFindOnePathParams["renditionId"], summaryId: SummarizationsControllerFindOnePathParams["summaryId"], params?: SummarizationsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<SummarizationsControllerFindOneQueryResponse, ResponseErrorConfig<SummarizationsControllerFindOne400 | SummarizationsControllerFindOne401 | SummarizationsControllerFindOne403 | SummarizationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? summarizationsControllerFindOneQueryKey(documentId, renditionId, summaryId, params);
  const query = useQuery({
    ...summarizationsControllerFindOneQueryOptions(documentId, renditionId, summaryId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SummarizationsControllerFindOne400 | SummarizationsControllerFindOne401 | SummarizationsControllerFindOne403 | SummarizationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}